import { NoddiTagBadge } from 'noddi-ui-web';
import { salesItemTagIcon } from './salesItemTagIcon';

interface Props {
  name: string;
  colorHex?: string | null;
  icon?: string | null;
  className?: string;
  selected?: boolean;
  size?: 'default' | 'sm';
}

export const SalesItemTagBadge = ({ icon, ...props }: Props) => (
  <NoddiTagBadge {...props} icon={salesItemTagIcon(icon)} />
);
